/**
 * Filtering for the "Añadir desde el TPV" dialog (spec 010-menu-platos-tpv).
 */
import type { CatalogItem } from '@/types/item';

export function normalizeText(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim();
}

export function inKnownCategories(item: CatalogItem, knownCategories: string[]): boolean {
  return item.square_categories.some((category) => knownCategories.includes(category));
}

/**
 * By default only products in the TPV categories where the restaurant already
 * has dishes are shown (mostly food, not drinks). With `showAll`, when the
 * restaurant has no dishes yet, or while searching, the whole catalog is used.
 * The search matches name and TPV categories, ignoring accents and case.
 */
export function filterCatalog(
  items: CatalogItem[],
  { query, showAll, knownCategories }: { query: string; showAll: boolean; knownCategories: string[] }
): CatalogItem[] {
  const needle = normalizeText(query);
  const restrict = !needle && !showAll && knownCategories.length > 0;

  return items.filter((item) => {
    if (restrict && !inKnownCategories(item, knownCategories)) return false;
    if (!needle) return true;
    return normalizeText([item.name, ...item.square_categories].join(' ')).includes(needle);
  });
}
